import React, { Component } from 'react';
import axios from 'axios'

import TimeForm from "./views/TimeForm";
import ContactForm from "./views/ContactForm";
import Confirmation from "./views/Confirmation";
import Programs from "./views/Programs";
import Options from "./views/Options";
import Complete from "./views/Complete";
import StepCounter from './components/Shared/StepCounter'
import data from './lib/evolve-all-data'

import logo from './images/logo-vertical.png'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currViewIndex: 0,
      locationData: data,
      views: ['home', 'options', 'programs', 'time', 'contact', 'confirmation', 'complete'],
      option: null,
      optionIndex: null,
      program: null,
      programIndex: null,
      event: null,
      eventIndex: null,
      day: null,
      dayIndex: 0,
      isGuardian: false,
      formData: {
        name: '',
        email: '',
        phone: '',
        children: []
      },
      isSubmitting: false
    }

    this.handleNextClick = this.handleNextClick.bind(this)
    this.handleBackClick = this.handleBackClick.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleProgramSelect = this.handleProgramSelect.bind(this)
    this.handleEventSelect = this.handleEventSelect.bind(this)
    this.handleChildRemove = this.handleChildRemove.bind(this)
    this.handleChildAdd = this.handleChildAdd.bind(this)
    this.handleChildInputChange = this.handleChildInputChange.bind(this)
    this.handleOptionSelect = this.handleOptionSelect.bind(this)
    this.handleDaySelect = this.handleDaySelect.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleGuardianClick = this.handleGuardianClick.bind(this)
  }

  static get apiUrlBase() {
    return process.env.REACT_APP_API_URI ||
      'https://ntqpip9a4g.execute-api.us-east-1.amazonaws.com/dev';   
  }

  handleInputChange (e) {
    const { formData } = this.state
    let newFormData = formData
    const name = e.target.name
    const value = e.target.value
    newFormData[name] = value
    this.setState({formData: newFormData})
  }

  handleDaySelect (day, dayIndex) {
    this.setState({
      day,
      dayIndex,
      eventIndex: null,
      event: null
    })
  }

  handleOptionSelect (option, optionIndex) {
    this.setState({option, optionIndex})
  }

  handleChildAdd () {
    const { formData } = this.state
    let newFormData = formData
    newFormData.children.push({name: '', age: ''})
    this.setState({formData: newFormData})

  }

  handleChildInputChange (e, i) {
    const { formData } = this.state
    let newFormData = formData
    const value = e.target.value
    const name = e.target.name

    newFormData.children[i][name] = value
    this.setState({formData: newFormData})
  }

  handleProgramSelect(program, i) {
    this.setState({
      program: program,
      programIndex: i
    })
  }

  handleGuardianClick() {
    const { isGuardian, formData } = this.state
    if (!isGuardian) {
      this.handleChildAdd()
      this.setState({isGuardian: true})
    } else {
      let newFormData = formData
      formData.children = []
      this.setState({
        isGuardian: false,
        formData: newFormData
      })
    }
  }

  handleChildRemove (index) {
    const { formData } = this.state
    let newFormData = formData
    newFormData.children.splice(index, 1)
    this.setState({formData: newFormData})

  }

  handleEventSelect(event, eventIndex) {
    this.setState({event, eventIndex})
  }

  handleNextClick () {
    const { currViewIndex } = this.state;
    let newViewIndex = currViewIndex;
    newViewIndex += 1;
    this.setState({currViewIndex: newViewIndex})
  }

  handleBackClick () {
    const { currViewIndex } = this.state;
    let newViewIndex = currViewIndex;
    newViewIndex -= 1;
    this.setState({currViewIndex: newViewIndex})
  }

  renderHome () {
    return (
      <section className="section animated fadeIn" style={{display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
        <div className="columns is-centered">
          <div className="column is-5 is-desktop">
            <div className="container has-text-left">
              <h1 className="title has-text-primary" style={{marginBottom: 30}}>
                Hello there!
              </h1>
              <p className="subtitle" style={{margin: '50px 0'}}>
                Let's help get you get started at <br/>
                EvolveAll!
              </p>
              <a className="button is-primary is-medium is-uppercase" onClick={this.handleNextClick}>Start</a>
            </div>
          </div>
        </div>
      </section>
    )
  }

  renderOptions () {
    return <Options {...this.state}
                    handleNextClick={this.handleNextClick}
                    handleChange={this.handleOptionSelect} />
  }

  renderPrograms () {
    return <Programs {...this.state}
                     handleChange={this.handleProgramSelect}
                     handleNextClick={this.handleNextClick}
                     handleBackClick={this.handleBackClick} />
  }

  renderTimeForm () {
    return <TimeForm {...this.state}
                     handleDaySelect={this.handleDaySelect}
                     handleChange={this.handleEventSelect}
                     handleNextClick={this.handleNextClick}
                     handleBackClick={this.handleBackClick} />
  }

  renderContactForm () {
    return <ContactForm {...this.state}
                        handleNextClick={this.handleNextClick}
                        handleChildAdd={this.handleChildAdd}
                        handleChildRemove={this.handleChildRemove}
                        handleGuardianClick={this.handleGuardianClick}
                        handleChange={this.handleInputChange}
                        handleChildInputChange={this.handleChildInputChange}
                        handleBackClick={this.handleBackClick}/>
  }

  renderConfirmation () {
    return <Confirmation {...this.state}
                         handleSubmit={this.handleSubmit}
                         handleNextClick={this.handleNextClick}
                         handleBackClick={this.handleBackClick} />
  }

  renderComplete () {
    return <Complete {...this.state}  />
  }

  handleSubmit () {
    const { program, formData, option, event, day } = this.state
    const data = {
      programCode: program.code,
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      isSelfParticipant: true,
      membership: option.value,
      eventName: event.name,
      eventDay: day,
      eventTime: event.time,
      participants: formData.children
    }

    this.setState({isSubmitting: true})
    axios.post(`${App.apiUrlBase}/signups`, data)
      .then(res => {
        if (res.status === 201) {
          this.setState({isSubmitting: false})
          this.handleNextClick()
        }
      })
      .catch(err => {
        console.log("Error: ", err)
      })
  }

  render() {
    const {views, currViewIndex } = this.state;
    const currView = views[currViewIndex];

    return (
      <div className="App" style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
        {currViewIndex !== 0 && <StepCounter currViewIndex={currViewIndex} views={views}/>}
        {currView === 'home' && this.renderHome()}
        {currView === 'options' && this.renderOptions()}
        {currView === 'programs' && this.renderPrograms()}
        {currView === 'time' && this.renderTimeForm()}
        {currView === 'contact' && this.renderContactForm()}
        {currView === 'confirmation' && this.renderConfirmation()}
        {currView === 'complete' && this.renderComplete()}
        <div style={{textAlign: 'center'}}>
          <p style={{fontSize: 10, marginBottom: 5}}>Powered By</p>
          <img style={{width: 100}} src={logo} alt=""/>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js